import {clientStaffRoutes} from '../utils';
import ExpensesTable from '@/views/expenses/ExpensesTable.vue';
import ExpensesCard from '@/views/expenses/ExpensesCard.vue';
import EmployeesConfigure from '@/views/employees/EmployeesConfigure';

export default [
   {
      name: 'employees-configure',
      path: '/company/:id/employees',
      component: EmployeesConfigure,
      meta: {
         breadCrumb: [
            {text: 'Dashboard', to: {name: 'Home'}},
            {
               text: '__COMPANYNAME__',
               // BreadCrumbs component fills id with current route param
               to: {name: 'company-detail', params: {id: 'FILL'}},
            },
            {text: 'Employees'},
         ],
         authGroup: 'rndig',
      },
   },

   ...clientStaffRoutes({
      name: 'employees-table',
      path: '/employees/table',
      component: ExpensesTable,
      props: {expenseType: 'employees'},
      stage: 'time',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Employees - Declaration'},
      ],
   }),

   ...clientStaffRoutes({
      name: 'employees-period-review',
      path: '/employees/:periodId/company',
      component: ExpensesCard,
      props: {expenseType: 'employees'},
      stage: 'time',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Employees', to: {name: 'employees-table-staff', params: {id: 'FILL'}}},
         {text: 'Employees - Review'},
      ],
   }),
];
